import React from "react";

export default function AnlagenFooter({formFactory, withAnlagenart}) {
    return (
        <>
            <div className="gridl" style={{gridTemplateColumns: "auto", paddingTop: "var(--vertical-spacing)"}}>
                {formFactory.renderInput("beschreibung", "beschreibung", "Beschreibung", "text", false, {
                    multiline: true,
                    minRows: 8,
                })}
            </div>
            <div className="gridl" style={{gridTemplateColumns: "auto auto auto", paddingTop: "var(--vertical-spacing)"}}>
                {withAnlagenart && formFactory.renderInput("anlagenart.value", "anlagenart.value", "Anlagenart", "text", true)}
            </div>
        </>
    );
}
